var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#F59B48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5038 27C24.1075 27 27.7196 21.613 27.7196 16.9421C27.7196 16.7887 27.7196 16.6365 27.7091 16.4849C28.4117 15.9852 29.0181 15.3649 29.5002 14.655C28.8457 14.941 28.1501 15.1286 27.4387 15.2113C28.1877 14.7693 28.7486 14.075 29.0172 13.2557C28.312 13.6675 27.5411 13.9582 26.7369 14.1141C25.3772 12.6909 23.103 12.622 21.6566 13.9607C20.7247 14.8239 20.3284 16.1109 20.618 17.3386C17.7313 17.1956 15.0415 15.8534 13.218 13.6454C12.2651 15.2607 12.7525 17.3263 14.3302 18.3635C13.7588 18.3472 13.1996 18.1957 12.7 17.9218V17.9666C12.7009 19.6491 13.9058 21.0978 15.5805 21.4312C15.052 21.5733 14.4973 21.594 13.96 21.4914C14.4299 22.9319 15.7783 23.9184 17.3139 23.9469C16.0426 24.9307 14.4719 25.4649 12.8549 25.4632C12.5696 25.4623 12.2844 25.4459 12 25.4123C13.6424 26.4496 15.5525 27 17.5038 26.9974",
    fill: "#F59B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTwitter);
export default __webpack_public_path__ + "static/media/svg_twitter.ffe3a2e028e0a2a99f7f5820c3ad5c8f.svg";
export { ForwardRef as ReactComponent };